import React from "react";
import SpotReviewDayGroups from "./SpotReviewDayGroups";

// Preview of spot reviews being drafted on the create-trip page. Uses the
// same day-grouped rendering as the trip-detail page so the composer and the
// final result stay visually consistent.
const DraftSpotReviews = ({ draftSpotReviews }) => {
    if (!draftSpotReviews || draftSpotReviews.length === 0) {
        return null;
    }
    return <SpotReviewDayGroups spotReviews={draftSpotReviews} isDraft={true} />;
};

export default DraftSpotReviews;
